import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import { subscriptionKeyFormat } from "utils/SubscriptionUtil";
import { CommonWrapper, Title } from "pages/subscription/SubscriptionStyled";

type Props = {
  page: number;
  value: string;
  onChangeKey: (string: string) => void;
};

export default function EnterKey(props: Props): JSX.Element {
  const isFirstPage = props.page === 0;

  return (
    <CommonWrapper>
      <Title>
        <Text style={{ whiteSpace: "break-spaces" }} fontSize={18} bold>
          {props.page === 0 && "Enter a subscription key to activate."}
          {props.page === 1 && "Subscription Key Information"}
        </Text>
        {props.page === 0 && <span className="essential">* Required</span>}
      </Title>
      <Input
        placeholder="Please enter a 20-digit code."
        disabled={!isFirstPage}
        value={props.value}
        onChange={(e) => props.onChangeKey(e.target.value)}
        data-testid="subscription-modal-activate-input-change-key"
      />
    </CommonWrapper>
  );
}
